import { createContext } from 'react';
export const initDrawerState = {
    isDrawerOpen: false,
};
export const drawerCtx = createContext([initDrawerState, () => { }]);
